import React from 'react'
import { Carousel } from '@moonpig/web-shared-components'

type ProductsCarouselProps = {
  ariaLabel: string
  children: React.ReactNode
  testId?: string
}

export const ProductsCarousel = ({
  ariaLabel,
  children,
  testId,
}: ProductsCarouselProps) => {
  return (
    <Carousel
      ariaLabel={ariaLabel}
      $noSpacing
      itemsGap={{ xs: 16, md: 16 }}
      data-testid={testId}
    >
      {children}
    </Carousel>
  )
}
